if (!customElements.get('pc437-personalizzazione')) {
  customElements.define('pc437-personalizzazione', class extends HTMLElement {
    connectedCallback() {
      this.config = JSON.parse(this.querySelector('[data-pc437-config]').textContent);
      this.productInfo = this.closest('product-info');
      if (!this.productInfo) return;
      this.onChange = () => this.update();
      this.onClick = (event) => {
        const button = event.target.closest('[data-pc437-quantity]');
        if (!button || !this.contains(button)) return;
        const input = this.productInfo.querySelector('input[name="quantity"]');
        if (!input) return;
        const quantity = Number(button.dataset.pc437Quantity);
        const minimum = Number(input.min || 1);
        const maximum = input.hasAttribute('max') ? Number(input.max) : Infinity;
        const step = Number(input.step || 1);
        if (quantity < minimum || quantity > maximum || (quantity - minimum) % step !== 0) return;
        input.value = String(quantity);
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
        this.update();
      };
      this.productInfo.addEventListener('change', this.onChange);
      this.addEventListener('click', this.onClick);
      this.update();
    }

    disconnectedCallback() {
      this.productInfo?.removeEventListener('change', this.onChange);
      this.removeEventListener('click', this.onClick);
    }

    update() {
      const selectedId = this.productInfo.querySelector('form[action*="/cart/add"] input[name="id"]')?.value;
      const variant = this.config.variants.find((item) => String(item.id) === String(selectedId));
      if (variant) {
        this.querySelector('[data-pc437-method-info]').textContent =
          variant.options[0].includes('DTF UV') ? this.config.dtfText : this.config.laserText;
      }
      const input = this.productInfo.querySelector('input[name="quantity"]');
      if (!input) return;
      const minimum = Number(input.min || 1);
      const maximum = input.hasAttribute('max') ? Number(input.max) : Infinity;
      const step = Number(input.step || 1);
      this.querySelectorAll('[data-pc437-quantity]').forEach((button) => {
        const quantity = Number(button.dataset.pc437Quantity);
        button.disabled = quantity < minimum || quantity > maximum || (quantity - minimum) % step !== 0;
        button.setAttribute('aria-pressed', String(Number(input.value) === quantity));
      });
    }
  });
}
